export default "__VITE_ASSET__BDc0ruPb__"